<template>
  <div class="apps" style="padding-top: 50px; overflow: hidden;">
    <img src="../../static/image/app_back.png" class="fullWidth" />
    <div style="height: 50px;"></div>
    <div style="height: 50px;"></div>
    <div
      class="alignCenter"
      style="font-family: 'Microsoft YaHei';font-size: 36px;color: #333333;"
    >APP应用开发</div>
    <div style="height: 30px;"></div>
    <div
      class="alignCenter"
      style="font-family: 'Microsoft YaHei';font-size: 16px;color: #999999"
    >提供APP开发、运维、及技术架构优化一站式服务</div>
    <div style="height: 30px;"></div>
    <Row type="flex" justify="center" class="code-row-bg">
      <Col span="2" v-for="(item,index) in appList" :key="index">
        <button
          v-if="!(Number(index)%2)"
          class="curP fullWidth iosNoXuan"
          :class="{iosXuan:item.isXuan}"
          @click="clickAppC(index)"
        >{{item.name}}</button>
      </Col>
    </Row>
    <div style="height: 50px;"></div>
    <Row type="flex" justify="center" class="code-row-bg">
      <Col offset="1">
        <div class="ios">
          <div class="andr">
            <p>{{name}}</p>
            <p>{{text1}}</p>
            <p>{{text2}}</p>
            <p>{{text3}}</p>
            <p>{{text4}}</p>
            <p>{{text5}}</p>
            <p>{{text6}}</p>
            <p>{{text7}}</p>
            <p>{{text8}}</p>
            <p>{{text9}}</p>
            <p>{{text10}}</p>
            <p>{{text11}}</p>
          </div>
          <img class="iosimg" :src="img_app" />
        </div>
      </Col>
    </Row>
    <div style="height: 50px;"></div>
    <div style="height: 50px;"></div>
    <div
      class="alignCenter"
      style="font-family: 'Microsoft YaHei';font-size: 36px;color: #333333;"
    >只为致力做好一件事</div>
    <div style="height: 30px;"></div>
    <div
      class="alignCenter"
      style="font-family: 'Microsoft YaHei';font-size: 16px;color: #999999"
    >专业视觉设计、用户行为研究、交互效果、技术服务以及基于移动端以及传统平台的营销支持</div>
    <div style="height: 30px;"></div>
    <Row type="flex" justify="center" class="code-row-bg">
      <Col span="16">
        <Row>
          <Col
            span="6"
            style="height: 350px;border-radius: 8px;"
            class="haoshi curP"
            v-for="(item,index) in youshiList"
            :key="index"
          >
            <div style="height: 175px;">
              <div class="BTjuzhongP">
                <div class="BTjuzhongC">
                  <img :src="item.imgs" class="centerLR imgite" />
                  <div
                    class="alignCenter"
                    style="font-family: 'Microsoft YaHei';font-size:14px;color: #333333;padding-top: 20px; "
                  >{{item.name}}</div>
                </div>
              </div>
            </div>
            <div style="height: 1px;background:#f5f5f5;margin: 0 20px;"></div>
            <div
              class="subite"
              style="height: 174px;padding: 30px 30px 0 30px;font-family: 'Microsoft YaHei';font-size: 14px;color: #999999"
            >{{item.subname}}</div>
          </Col>
        </Row>
      </Col>
    </Row>
    <div style="height:100px;"></div>
    <xfck></xfck>
  </div>
</template>

<script>
import xfck from "./xfck.vue";
var img_url_i = "";
// if (window.location.host.slice(0, 5) === "local") {
//   img_url_i = "..";
// } else {
//   img_url_i = "/jianyunPC";
// }
export default {
  name: "apps",
  data() {
    return {
      appList: [
        {
          name: "IOS应用开发",
          isXuan: true,
          imgs: img_url_i + "/static/app/appo.jpg",
          text1:
            "为客户提供全专业的APP软件开发解决方案, 凭借多年的行业开发经验,从品牌和市场的角度, 用专业的研发技术,为企业吸引、留住用户。",
          text2: "开发流程",
          text3: "01.用户需求分析",
          text4: "02.产品原型设计",
          text5: "03.UI视觉设计",
          text6: "04.数据库搭建",
          text7: "05.服务端开发",
          text8: "06. IOS客户端开发",
          text9: "07.APP程序测试",
          text10: "08.上传到应用商店",
          text11: "09.APP的维护及更新"
        },
        { name: "&nbsp;" },
        {
          name: "Android APP开发",
          isXuan: false,
          imgs: img_url_i + "/static/app/anzhuo.jpg",
          text1:
            "我们拥有专业的研发团对，可根据客户提出的 各项需求提供高品质APP开发解决方案！熟练的掌握着安卓开发技术，已先后为上百家企业提供Android手机开发服务。",
          text2: "开发流程",
          text3: "01.用户需求分析",
          text4: "02.产品原型设计",
          text5: "03.UI视觉设计",
          text6: "04.数据库搭建",
          text7: "05.服务端开发",
          text8: "06.Android客户端开发",
          text9: "07.APP程序测试",
          text10: "08.上传到应用商店",
          text11: "09.APP的维护及更新"
        }
      ],
      name: "IOS应用开发",
      img_app: img_url_i + "/static/app/appo.jpg",
      text1:
        "为客户提供全专业的APP软件开发解决方案, 凭借多年的行业开发经验,从品牌和市场的角度, 用专业的研发技术,为企业吸引、留住用户。",
      text2: "开发流程",
      text3: "01.用户需求分析",
      text4: "02.产品原型设计",
      text5: "03.UI视觉设计",
      text6: "04.数据库搭建",
      text7: "05.服务端开发",
      text8: "06. IOS客户端开发",
      text9: "07.APP程序测试",
      text10: "08.上传到应用商店",
      text11: "09.APP的维护及更新",
      youshiList: [
        {
          name: "餐饮外卖",
          imgs: img_url_i + "/static/image/canyin.png",
          subname:
            "餐厅展示、美食展示、订位点餐、 呼叫服务、在线支付、用餐点评等"
        },
        {
          name: "教育行业",
          imgs: img_url_i + "/static/image/jiaoyu.png",
          subname: "在线交流、教学视频、线上课程、 预约上课、效果分享等"
        },
        {
          name: "医疗行业",
          imgs: img_url_i + "/static/image/yiliao.png",
          subname:
            "在线咨询、手机挂号、电子药方、 药价对比、在线支付、健康监测等"
        },
        {
          name: "电商行业",
          imgs: img_url_i + "/static/image/dianshang.png",
          subname: "产品展示、产品推荐、购物车、 订单管理、商品管理、在线支付等"
        },
        {
          name: "金融行业",
          imgs: img_url_i + "/static/image/jinrong.png",
          subname: "行情分析、消息推送、用户认证、 及时行情推送、用户认证等"
        },
        {
          name: "社交APP",
          imgs: img_url_i + "/static/image/shejiao.png",
          subname: "好友添加、圈子互动、好友聊天、 记事本、附近人等"
        },
        {
          name: "地产行业",
          imgs: img_url_i + "/static/image/dichan.png",
          subname: "房产信息、推荐奖励、找房功能、 预约看房、购房指南等"
        },
        {
          name: "运动APP",
          imgs: img_url_i + "/static/image/ren.png",
          subname: "综合健康管理、卡路里计算、记步、 健身方案、高清视频等"
        }
      ]
    };
  },
  methods: {
    clickAppC(index) {
      var that = this;
      that.appList.map(function(item) {
        item.isXuan = false;
      });
      that.appList[index].isXuan = true;
      that.img_app = that.appList[index].imgs;
      that.name = that.appList[index].name;
      that.text1 = that.appList[index].text1;
      that.text2 = that.appList[index].text2;
      that.text3 = that.appList[index].text3;
      that.text4 = that.appList[index].text4;
      that.text5 = that.appList[index].text5;
      that.text6 = that.appList[index].text6;
      that.text7 = that.appList[index].text7;
      that.text8 = that.appList[index].text8;
      that.text9 = that.appList[index].text9;
      that.text10 = that.appList[index].text10;
      that.text11 = that.appList[index].text11;
    }
  },
  components: {
    xfck
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.nameite {
  position: absolute;
  top: 120px;
  left: 40px;
}
.subite {
  margin-left: 10px;
  margin-right: 10px;
}
.imgite {
  margin-top: 50px;
  width: 60px;
  /* height: 50px; */
}
@media (min-width: 1090px) {
  .andr {
    border: 1px solid #dedddd;
    width: 500px;
    height: 600px;
    top: 7%;
    left: -10%;
    background: rgba(255, 255, 255, 1);
    position: absolute;
  }
  p {
    margin: 0px 30px;
  }
  p:nth-child(1) {
    margin-top: 12%;
    font-size: 24px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 5px;
  }
  p:nth-child(2) {
    height: 17%;
    margin-top: 5%;
    font-size: 14px;
    font-family: MicrosoftYaHeiLight;
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    line-height: 26px;
  }
  p:nth-child(3) {
    margin-top: 5%;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 26px;
  }
  p:nth-child(4) {
    margin-top: 5%;
  }
  p:nth-child(12) {
    margin-bottom: 20%;
  }
  p {
    height: 5%;
    font-size: 14px;
    font-family: MicrosoftYaHeiLight;
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    line-height: 26px;
  }
  .iosimg {
    /* width: 1046px; */
    height: 698px;
  }
}

@media (max-width: 1090px) {
  .andr {
    border: 1px solid #dedddd;
    width: 400px;
    height: 520px;
    top: 7%;
    left: -10%;
    background: rgba(255, 255, 255, 1);
    position: absolute;
  }
  p {
    margin: 0px 30px;
  }
  p:nth-child(1) {
    margin-top: 12%;
    font-size: 24px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
  }
  p:nth-child(2) {
    height: 17%;
    margin-top: 5%;
    font-size: 14px;
    font-family: MicrosoftYaHeiLight;
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    line-height: 20px;
  }
  p:nth-child(3) {
    margin-top: 5%;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 26px;
  }
  p:nth-child(4) {
    margin-top: 5%;
  }
  p:nth-child(12) {
    margin-bottom: 20%;
  }
  p {
    height: 5%;
    font-size: 14px;
    font-family: MicrosoftYaHeiLight;
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    line-height: 26px;
  }
  .iosimg {
    /* width: 900px; */
    height: 600px;
  }
  .centerLR {
    padding-top: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/app.vue